module.exports = __webpack_public_path__ + "img/loan-circle.dfc868ac.svg";